import { render, staticRenderFns } from "./PreviewPaywall.vue?vue&type=template&id=0b5cd1e2&scoped=true"
import script from "./PreviewPaywall.vue?vue&type=script&lang=js"
export * from "./PreviewPaywall.vue?vue&type=script&lang=js"
import style0 from "./PreviewPaywall.vue?vue&type=style&index=0&id=0b5cd1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5cd1e2",
  null
  
)

export default component.exports